import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from "react";
import styled from "styled-components";
import axios from "axios";
import moment from "moment";

const Wrapper = styled.div`
  background: white;
  padding: 2rem;
  // margin: 2rem auto;
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);

  @media (max-width: 768px) {
    width: 95%;
    padding: 1rem;
    margin: 1rem auto;
  }
`;

const Heading = styled.h3`
  margin-bottom: 2rem;
  font-size: 1.4rem;
  color: #1e3a8a;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }
`;

const BarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top:0.5rem;

  @media (max-width: 768px) {
    gap: 0.7rem;
  }
`;

const DayRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media (max-width: 768px) {
    gap: 0.8rem;
  }
`;

const DateLabel = styled.div`
  width: 60px;
  text-align: right;
  font-weight: 600;
  color: #444;
  font-size: 0.95rem;

  @media (max-width: 768px) {
    width: 70px;
    font-size: 0.8rem;
  }
`;

const BarWrapper = styled.div`
  flex: 1;
  height: 30px;
  border-radius: 10px;
  background: #f1f1f1;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 20px;
  }
`;

const BarFill = styled.div`
  height: 100%;
  // width: ${(props) => props.width}%;
  // width: ${(props) => Math.max(props.width, 15)}%;
  width: ${(props) => (props.width > 0 ? Math.max(props.width, 5) : 15)}%;

  background: ${(props) => props.color};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 10px;
  color:"rgba(0, 0, 0, 0.1)",
  font-weight: bold;
  font-size: 0.9rem;
  transition: width 0.5s ease;

  @media (max-width: 768px) {
    font-size: 0.65rem;
    padding-right: 6px;
      width: ${(props) => (props.width > 0 ? Math.max(props.width, 5) : 30)}%;
  }
`;

const SummarySection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1.5rem;

  @media (max-width: 768px) {
    gap: 0.8rem;
    margin-top: 1.25rem;
  }

  @media (max-width: 480px) {
    gap: 0.6rem;
    margin-top: 1rem;
  }
`;

export const SummaryCard = styled.div`
  flex: 1;
  min-width: 140px;
  background-color: ${(props) => props.bgColor || "#fff"};
  padding: 0.75rem 0.5rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  max-width: 180px;
  transition: all 0.3s ease;

  @media (max-width: 1024px) {
    padding: 0.7rem 0.45rem;
    max-width: 160px;
  }

  @media (max-width: 768px) {
    min-width: 120px;
    max-width: 140px;
    padding: 0.65rem 0.4rem;
  }

  @media (max-width: 480px) {
    min-width: 100px;
    max-width: 120px;
    padding: 0.6rem 0.35rem;
  }
`;

export const CardTitle = styled.h4`
  font-size: 0.75rem;
  color: #555;
  margin-bottom: 0.4rem;
  margin-top: 0;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 0.7rem;
    margin-bottom: 0.35rem;
  }

  @media (max-width: 480px) {
    font-size: 0.65rem;
    margin-bottom: 0.3rem;
  }
`;

export const CardValue = styled.h3`
  font-size: 1.1rem;
  font-weight: bold;
  color: ${(props) => props.color || "#000"};
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.7rem;
  }
`;

const Highlight = styled.h3`
  // color: var(--primary);
    color: #004080;
    margin-bottom:0.5rem;
`;

const Container = styled.div`
  background-color: #fff;
  height: 100%;
  padding: 1rem;
  // box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  width: 100%;
  border-radius: 20px;
`;

const MotorWeeklyRuntimeChart = forwardRef(({ motor_id, startDate, token, location_name }, ref) => {
  const exportRef = useRef();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState("");
  const [totalPower, setTotalPower] = useState("");
  const [loading, setLoading] = useState(true);
  const [unitRate, setUnitRate] = useState(0);
  const [totalCost, setTotalCost] = useState(0);

  useImperativeHandle(ref, () => ({
    getElement: () => exportRef.current,
  }));

  // useEffect(() => {
  //   async function fetchWeeklyData() {
  //     if (!motor_id || !startDate) return;

  //     setLoading(true);
  //     try {
  //       const url = `${process.env.REACT_APP_API}/sensor/motor-weekly-runtime?motor_id=${motor_id}&start_date=${startDate}`;
  //       const res = await axios.get(url, {
  //         headers: { Authorization: token[0] },
  //       });

  //       const days = res.data.days || [];
  //       setData(days);
  //       setTotal(res.data.total_weekly_run_time || "0 mins");
  //       setTotalPower(res.data.total_power_consumption_kWh || "0 kWh");
  //     } catch (err) {
  //       console.error("Error fetching weekly runtime:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }

  //   fetchWeeklyData();
  // }, [motor_id, startDate, token]);

  useEffect(() => {
    async function fetchWeeklyData() {
      if (!motor_id || !startDate) return;
      setLoading(true);
      const org_id = localStorage.getItem("org_id");

      try {
        const url = `${process.env.REACT_APP_API}/sensor/motor-weekly-runtime?motor_id=${motor_id}&start_date=${startDate}`;
        const res = await axios.get(url, {
          headers: { Authorization: token[0] },
        });

        const days = res.data.days || [];
        const weeklyTotalPower = parseFloat(res.data.total_power_consumption_kWh || 0);

        setData(days);
        setTotal(res.data.total_weekly_run_time || "0 mins");
        setTotalPower(weeklyTotalPower);


        const month = moment(startDate).month() + 1;
        const year = moment(startDate).year();

        const rateRes = await axios.get(
          `${process.env.REACT_APP_API}/user/unitrate/monthly/${org_id}/${year}/${month}`,
          { headers: { Authorization: token[0] } }
        );

        const rate = rateRes?.data?.data?.current_unit_rate || 7.35;
        setUnitRate(rate);

        const cost = (weeklyTotalPower * rate).toFixed(2);
        setTotalCost(cost);
      } catch (err) {
        console.error("Error fetching weekly runtime or rate:", err);
        setTotalCost(0);
      } finally {
        setLoading(false);
      }
    }

    fetchWeeklyData();
  }, [motor_id, startDate, token]);

  // const filteredData = data.filter((d) => {
  //   if (!d.run_time) return false;

  //   if (d.run_time.trim().toLowerCase() === "0 mins") return false;

  //   return true;
  // });

  const filteredData = data.filter((d) => {
    if (!d.run_time) return false;

    const clean = d.run_time.trim().toLowerCase();

    if (clean === "0 mins") return false;

    if (/^0\s*hrs?\s*0\s*mins?$/.test(clean)) return false;

    const hoursMatch = clean.match(/(\d+)\s*hrs?/);
    const minsMatch = clean.match(/(\d+)\s*mins?/);

    const hours = hoursMatch ? parseInt(hoursMatch[1]) : 0;
    const mins = minsMatch ? parseInt(minsMatch[1]) : 0;

    return hours + mins > 0;
  });

  if (loading) return <Wrapper>Loading weekly runtime...</Wrapper>;

  //   if (!loading && (!data || data.length === 0 || !data.some((d) => d.run_time && d.run_time.trim() !== "" && d.run_time.trim() !== "0 mins"))) {
  //   return (
  //     <Container ref={exportRef}>
  //       <p>
  //         No data available for this week.
  //       </p>
  //     </Container>
  //   );
  // }

  if (!loading && filteredData.length === 0) {
    return (
      <Container ref={exportRef}>
        <p>No data available for this week.</p>
      </Container>
    );
  }

  const toMinutes = (str) => {
    const match = str.match(/(\d+)\s*hrs?\s*(\d+)?\s*mins?/);
    if (!match) return 0;
    const hours = parseInt(match[1] || 0);
    const mins = parseInt(match[2] || 0);
    return hours * 60 + mins;
  };

  const maxMinutes = filteredData.length
    ? Math.max(...filteredData.map((d) => toMinutes(d.run_time)))
    : 0;

  const colors = [
    "rgba(99, 155, 245, 0.7)",
    'rgba(163, 199, 244, 0.7)',
  ];

  return (
    <Wrapper ref={exportRef}>
      <div>
        <Highlight>{location_name}</Highlight>
        <h5>
          Weekly Motor Runtime from{" "}
          {moment(startDate).startOf("week").format("MMM DD, YYYY")} to{" "}
          {moment(startDate).endOf("week").format("MMM DD, YYYY")}
        </h5>
      </div>
      {/* <BarContainer>
        {data
        .filter((day) => day.run_time && day.run_time.trim() !== "0 mins" && day.run_time.trim() !== "")
        .map((day, i) => {
          const mins = toMinutes(day.run_time);
          const width = maxMinutes > 0 ? (mins / maxMinutes) * 100 : 0;
          const color = colors[i % colors.length];
          const formattedDate = new Date(day.date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
          });

          return (
            <DayRow key={i}>
              <DateLabel>{formattedDate}</DateLabel>
              <BarWrapper>
                <BarFill width={width} color={color}>
                  {day.run_time}
                </BarFill>
              </BarWrapper>
            </DayRow>
          );
        })}

      </BarContainer> */}

      <BarContainer>
        {filteredData.map((day, i) => {
          const mins = toMinutes(day.run_time);
          const width = maxMinutes > 0 ? (mins / maxMinutes) * 100 : 0;
          const color = colors[i % colors.length];

          const formattedDate = new Date(day.date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
          });

          return (
            <DayRow key={i}>
              <DateLabel>{formattedDate}</DateLabel>
              <BarWrapper>
                <BarFill width={width} color={color}>
                  {/* {mins > 0 ? day.run_time : null} */}
                  {day.run_time}
                </BarFill>
              </BarWrapper>
            </DayRow>
          );
        })}
      </BarContainer>


      <SummarySection>
        <SummaryCard bgColor="#e3f2fd">
          <CardTitle>Total Runtime</CardTitle>
          <CardValue color="#1e3a8a">{total}</CardValue>
          {/* <CardSubtext>This Week</CardSubtext> */}
        </SummaryCard>

        <SummaryCard bgColor="#fff3e0">
          <CardTitle>Power Consumed</CardTitle>
          <CardValue color="#e65100">{totalPower} kWh</CardValue>
          {/* <CardSubtext>Energy Usage</CardSubtext> */}
        </SummaryCard>

        <SummaryCard bgColor="#e8f5e9">
          <CardTitle>Total Cost</CardTitle>
          <CardValue color="#2e7d32">₹ {totalCost}</CardValue>
        </SummaryCard>
      </SummarySection>
    </Wrapper>
  );
});

export default MotorWeeklyRuntimeChart;